import type * as React from 'react';
const SvgIcoUser = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path d="M3.25 19.25a5 5 0 0 1 5-5h7.5a5 5 0 0 1 5 5V20a.75.75 0 0 1-1.5 0v-.75a3.5 3.5 0 0 0-3.5-3.5h-7.5a3.5 3.5 0 0 0-3.5 3.5V20a.75.75 0 0 1-1.5 0zM12 3.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M7.25 7a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0" />
    </g>
  </svg>
);
export default SvgIcoUser;
